<template>
  <v-navigation-drawer
    app
    :dark="dark"
    clipped
    fixed
    v-model="drawer"
    enable-resize-watcher
  >
    <v-list v-if="user !== null" dense>
      <template v-for="(menuItem, index) in menuItems">
        <v-list-tile
          v-if="menuItem.menuable.__typename === 'ContentPage'"
          :key="menuItem.id"
          :href="'/content-pages/' + menuItem.menuable.id"
        >
          <v-list-tile-action v-if="menuItem.menuable.legacy_icon">
            <v-icon>{{ menuItem.menuable.legacy_icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ menuItem.menuable.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group
          v-else-if="
            menuItem.menuable.__typename === 'MenuGroup' &&
              menuItem.menuable.contentPages.length > 0
          "
          :key="menuItem.id"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>{{
                menuItem.menuable.title
              }}</v-list-tile-title>
            </v-list-tile>
          </template>

          <v-list-tile
            v-for="page in menuItem.menuable.contentPages"
            :key="page.id"
            :href="'/content-pages/' + page.id"
          >
            <v-list-tile-action v-if="page.legacy_icon">
              <v-icon>{{ page.legacy_icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ page.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-divider />
      </template>

      <v-list-group
        :value="activeGroup === 'meldeportal'"
        v-if="!user.is_younger_than_18"
      >
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Meldeportal</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile
          router
          to="/user/dashboard"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>dashboard</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Dashboard</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="!user.is_younger_than_18"
          router
          to="/user/dancer"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>person</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-t="'menu.items.dancers'"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="!user.is_younger_than_18"
          router
          to="/user/starter-template"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>group</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-t="'menu.items.starters'"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="!user.is_younger_than_18"
          router
          to="/user/events"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>event</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-t="'menu.items.events'"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="registrations.items.length > 0 && !user.is_younger_than_18"
          router
          to="/user/event-registration-list"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>event_available</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-t="'menu.items.event_registration_list'"
            ></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>

      <v-list-group
        :value="activeGroup === 'admin'"
        v-if="user.is_organizer || $hasRole('admin')"
      >
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Admin-Funktionen</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile
          v-if="$hasRole('admin')"
          router
          to="/admin/events"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>event_note</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-t="'menu.items.admin.contests'"
            ></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="user.is_organizer || $hasRole('admin')"
          router
          to="/event-reports"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>assignment</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-t="'menu.items.admin.contest_reports'"
            ></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="$hasRole('admin')"
          router
          to="/admin/users"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>account_box</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-t="'menu.items.admin.users'"
            ></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--        <v-list-tile v-if="$hasRole('admin')" router to="/admin/translations"-->
        <!--                     :disabled="!user.valid && !$hasRole('admin')">-->
        <!--          <v-list-tile-action>-->
        <!--            <v-icon>map</v-icon>-->
        <!--          </v-list-tile-action>-->
        <!--          <v-list-tile-content>-->
        <!--            <v-list-tile-title v-t="'menu.items.admin.translations'"></v-list-tile-title>-->
        <!--          </v-list-tile-content>-->
        <!--        </v-list-tile>-->
        <v-list-tile
          v-if="$hasRole('admin')"
          router
          to="/admin/refund"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>assignment_late</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-t="'menu.items.admin.refund'"
            ></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="$hasRole('admin')"
          href="/admin/emails"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>mail</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Email-Verwaltung</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="$hasRole('admin')"
          href="/admin/menu-items"
          :disabled="!user.valid && !$hasRole('admin')"
        >
          <v-list-tile-action>
            <v-icon>menu_open</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Menü-Verwaltung</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>

      <v-divider dark></v-divider>

      <v-list-tile
        router
        to="/user/settings"
        :disabled="!user.valid && !$hasRole('admin')"
      >
        <v-list-tile-action>
          <v-icon>settings</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-t="'menu.items.settings'"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider dark></v-divider>

      <v-list-tile @click="logoutDialog = true">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-t="'logout'">
            <confirmation-dialog
              :value.sync="logoutDialog"
              ok-label="logout"
              @ok="logout"
              :title="$t('really_logout')"
            >
              <p slot="content" v-t="'do_you_really_wanna_logout'"></p>
            </confirmation-dialog>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-list v-else dense>
      <v-list-tile router to="/login">
        <v-list-tile-action>
          <v-icon>login</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Login</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile router href="/registration">
        <v-list-tile-action>
          <v-icon>person_add</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-t="'register'"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import ConfirmationDialog from "./dialogs/ConfirmationDialog";

export default {
  components: {
    ConfirmationDialog
  },
  data() {
    return {
      logoutDialog: false,
      drawer: null,
      activeGroup: "meldeportal",
      menuItems: []
    };
  },
  computed: {
    dark() {
      if (this.user !== null && this.user.white_navigation !== undefined) {
        return !this.user.white_navigation;
      }

      return true;
    },
    ...mapState(["user", "registrations"])
  },
  created() {
    const query = `
      query {
        menuItems (visible: true) {
          id, menuable_id, menuable_type, position, visible, public
          menuable {
            __typename
            ... on ContentPage {
              id, legacy_icon, title, content
            }
            ... on MenuGroup {
              title,
              contentPages {
                id, legacy_icon, title, content
              }
            }
          }
        }
      }
    `;
    axios
      .post(
        "/graphql",
        {
          operationName: null,
          query: query,
          input: {}
        },
        {
          baseURL: ""
        }
      )
      .then(
        response => {
          if (!response.data.data) {
            return;
          }

          this.menuItems = response.data.data.menuItems.sort(
            (a, b) => a.position - b.position
          );
        },
        errorResponse => {}
      );
  },
  mounted() {
    Vue.prototype.$setDrawer = state => {
      this.drawer = state;
    };
    Vue.prototype.$toggleDrawer = () => {
      this.drawer = !this.drawer;
    };

    if (/admin/.test(this.$route.path)) {
      this.activeGroup = "admin";
    }
  },
  methods: {
    logout() {
      this.logoutDialog = false;
      this.$logout();
    }
  }
};
</script>
